export enum ChannelTypeEnum {
  application = 1,
  admin,
  portal
}
